import { supabase } from './supabase';

export interface HeaderCategory {
  id: string;
  key: string;
  label_en: string | null;
  label_ar: string | null;
  label_fr: string | null;
  display_order: number;
  is_active: boolean;
}

export type HeaderCategoryInput = {
  key: string;
  label_en?: string;
  label_ar?: string;
  label_fr?: string;
  display_order?: number;
  is_active?: boolean;
};

export const headerCategoriesService = {
  async getCategories() {
    const { data, error } = await supabase
      .from('header_categories')
      .select('*')
      .order('display_order', { ascending: true });

    return { data: data as HeaderCategory[] | null, error };
  },

  async getActiveCategories() {
    const { data, error } = await supabase
      .from('header_categories')
      .select('*')
      .eq('is_active', true)
      .order('display_order', { ascending: true });

    return { data: data as HeaderCategory[] | null, error };
  },

  async createCategory(input: HeaderCategoryInput) {
    const payload = {
      display_order: 0,
      is_active: true,
      ...input,
    };

    const { data, error } = await supabase
      .from('header_categories')
      .insert(payload)
      .select()
      .single();

    return { data: data as HeaderCategory | null, error };
  },

  async updateCategory(
    id: string,
    updates: Partial<HeaderCategoryInput>
  ) {
    const { data, error } = await supabase
      .from('header_categories')
      .update(updates)
      .eq('id', id)
      .select()
      .single();

    return { data: data as HeaderCategory | null, error };
  },

  async deleteCategory(id: string) {
    const { error } = await supabase
      .from('header_categories')
      .delete()
      .eq('id', id);

    return { error };
  },
};